import get from 'lodash/get';
import { createRoot } from 'react-dom/client';
import { Route } from 'react-router-dom';

import PackWrapper from 'components/common/PackWrapper';
import NutritionalFactsContainer from 'components/nutritionFacts/NutritionalFactsContainer';
import { getStore } from 'store/configure';
import { getBrowserHistory } from 'utilities/router';

const history = getBrowserHistory();
const store = getStore();

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.querySelector('#nutrition-facts-panel');
  const mealHashId = get(rootElement, 'dataset.mealHashId');
  const root = createRoot(rootElement);

  root.render(
    <PackWrapper rootElement={rootElement} store={store} history={history}>
      {mealHashId ? (
        <NutritionalFactsContainer domMealId={mealHashId} />
      ) : (
        <Route path="/qr/:mealId/:packingFacility" component={NutritionalFactsContainer} />
      )}
    </PackWrapper>
  );
});
